import Payments from '../../../../api/api-payments';
import * as types from '../constants/action-types';

const fetchBookingPaymentRequest = (bookingToFetch) => {
  return {
    type: types.BOOKING_PAYMENT_FETCH_REQUEST,
    bookingToFetch
  };
};

const fetchBookingPaymentSuccess = (data) => {
  return {
    type: types.BOOKING_PAYMENT_FETCH_SUCCESS,
    data
  };
};

const fetchBookingPaymentFailure = (fetchError) => {
  return {
    type: types.BOOKING_PAYMENT_FETCH_FAILURE,
    fetchError
  };
};

export const fetchPayment = (bookingId, token, ssoId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchBookingPaymentRequest());
      Payments.getBookingPaymentData(bookingId, token, ssoId, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchBookingPaymentSuccess(response));

          return resolve(response);
        }
        const error = (response || {}).error;
        dispatch(fetchBookingPaymentFailure(error));
        return reject(error);
      });
    });
  };
};
